import { render, staticRenderFns } from "./SchoolBanner3.vue?vue&type=template&id=2d726d34&"
import script from "./SchoolBanner3.vue?vue&type=script&lang=js&"
export * from "./SchoolBanner3.vue?vue&type=script&lang=js&"
import style0 from "./SchoolBanner3.vue?vue&type=style&index=0&id=2d726d34&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports